import flickityAsNavFor from "flickity-as-nav-for";
import FlickityClass from "common/utils/ui/flickity-class";
import initMastheadMenu from "components/masthead/component";
import initMastheadSearchBar from "components/jiffy/masthead-redesign2025/search-bar/search-bar";
import initMastheadSearchDropdown from "components/jiffy/masthead-redesign2025/search-dropdown/search-dropdown";
import initMastheadCartDropdown from "components/jiffy/masthead-cart-dropdown/masthead-cart-dropdown";
import { Redesign2025Masthead } from "components/masthead/redesign2025-masthead";
import { SubmenuScrollClass } from "./mobile/submenu-scroll-class";
import "components/jiffy/design-with-ai-cta/design-with-ai-cta";

const initSlider = () =>
  new FlickityClass(
    ".js-masthead-redesign2025-slider",
    {
      selectedAttraction: 0.01,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: 5000,
      pauseAutoPlayOnHover: true
    },
    {
      library: flickityAsNavFor
    }
  ).initFlickity();

const initAccountDropdown = () => {
  new Redesign2025Masthead({
    selector: ".js-account-dropdown-menu"
  }).init();
  new Redesign2025Masthead({
    selector: ".js-more-customizable-menu"
  }).init();
};

const initMobileSubmenu = () => {
  new SubmenuScrollClass({
    submenuSelector: ".js-submenu-mobile",
    activeItemSelector: ".js-submenu-mobile-active"
  }).scrollToActive();
};

const init = () => {
  initSlider();
  initAccountDropdown();
  initMastheadCartDropdown();
  initMastheadMenu();
  initMastheadSearchBar();
  initMastheadSearchDropdown();
  initMobileSubmenu();
};

export default init;
